import { DateTime } from 'luxon';

import isEmpty from 'lib/utils/formValidation/isEmpty';

interface FormDateValue {
  month: number;
  day: number;
  year: number;
}

const isValidDate = (value: any) => {
  if (!value) {
    return true;
  }

  const castedFormValue = value as FormDateValue;

  // Allow fully empty dates, and valid ones (no incomplete dates)
  return (
    (isEmpty(castedFormValue.month) &&
      isEmpty(castedFormValue.day) &&
      isEmpty(castedFormValue.year)) ||
    (!isEmpty(castedFormValue.month) &&
      !isEmpty(castedFormValue.day) &&
      !isEmpty(castedFormValue.year) &&
      DateTime.local(castedFormValue.year, castedFormValue.month, castedFormValue.day).isValid)
  );
};

export default isValidDate;
